import { ResourceCornSchema, TagSchema } from '../tag.js';
export const PutTagColorBodyRequestSchema = TagSchema.required()
    .pick({
    key: true,
    value: true,
    color: true,
})
    .partial({ value: true });
export const PutTagColorPathRequestSchema = ResourceCornSchema;
export const PutTagColorRequestSchema = PutTagColorBodyRequestSchema.and(PutTagColorPathRequestSchema);
export const PutTagColorResponseSchema = TagSchema;
